import type { ReactNode } from 'react';
import { Group, Title } from '@mantine/core';
import { TOKENS } from '../theme';

/**
 * A page's title row: the title, an optional status beside it, and actions on the right.
 *
 * The title is Inter 600 with the site's -0.02em tracking, which is most of
 * what separates a heading from a label at this size.
 */
export function PageHeader({
  title,
  status,
  description,
  actions,
}: {
  title: ReactNode;
  status?: ReactNode;
  description?: ReactNode;
  actions?: ReactNode;
}) {
  return (
    <Group justify="space-between" align="center" gap="md" wrap="wrap">
      <div style={{ minWidth: 0 }}>
        <Group gap={16} align="center" wrap="wrap">
          <Title
            order={2}
            style={{ fontSize: 24, lineHeight: 1.2, letterSpacing: '-0.02em', color: TOKENS.text }}
          >
            {title}
          </Title>
          {status}
        </Group>
        {description && (
          <div style={{ marginTop: 4, fontSize: 13, color: TOKENS.textSecondary }}>{description}</div>
        )}
      </div>
      {actions && <Group gap="sm">{actions}</Group>}
    </Group>
  );
}
